import { Joyride, ACTIONS, EVENTS, STATUS } from "react-joyride";
import { alpha } from "@mui/material/styles";

import { useTourContext } from "context/TourContext";
import { danhDauDaXemTour } from "lib/tourDaXem";
import { danhDauHoanThanhLuong } from "lib/luongTour";
import { SEMANTIC, FONT_CHU, RADIUS, MAU } from "assets/theme/avocadoBrand";

const NHAN = {
  back: "Quay lại",
  close: "Đóng",
  last: "Xong",
  next: "Tiếp theo",
  nextWithProgress: "Tiếp ({current}/{total})",
  open: "Mở hướng dẫn",
  skip: "Bỏ qua",
};

const KET_THUC = [STATUS.FINISHED, STATUS.SKIPPED];

function TourRunner() {
  const { active, stopActiveTour } = useTourContext();

  function handleEvent(data) {
    const { status, action, type } = data;
    const ketThuc =
      KET_THUC.includes(status) || type === EVENTS.TOUR_END || action === ACTIONS.SKIP;

    if (!ketThuc) return;

    if (active?.laLuong) {
      // Bỏ qua giữa luồng = không ép nữa. Xong chặng cuối = hoàn tất luồng.
      if (action === ACTIONS.SKIP || status === STATUS.SKIPPED || active.laChangCuoi) {
        danhDauHoanThanhLuong(active.tourId, active.uid);
      }
      stopActiveTour();
      return;
    }

    if (active?.tourId) danhDauDaXemTour(active.tourId, active.uid);
    stopActiveTour();
  }

  if (!active || !active.steps?.length) return null;

  return (
    <Joyride
      key={`${active.tourId}-${active.runSession ?? 0}`}
      steps={active.steps}
      run={!!active.run}
      continuous
      scrollToFirstStep
      onEvent={handleEvent}
      locale={NHAN}
      options={{
        primaryColor: SEMANTIC.primary,
        textColor: SEMANTIC.textPrimary,
        backgroundColor: SEMANTIC.surface,
        arrowColor: SEMANTIC.surface,
        overlayColor: alpha(MAU.ink, 0.55),
        zIndex: 1500,
        skipBeacon: true,
        showProgress: true,
        buttons: ["back", "close", "primary", "skip"],
        closeButtonAction: "skip",
        overlayClickAction: false,
        targetWaitTimeout: 1200,
        width: 400,
      }}
      styles={{
        tooltip: {
          borderRadius: RADIUS.md,
          fontFamily: FONT_CHU,
          fontSize: "0.9rem",
          lineHeight: 1.45,
        },
        tooltipContent: {
          padding: "4px 0 0",
        },
        buttonPrimary: {
          borderRadius: RADIUS.sm,
          fontFamily: FONT_CHU,
        },
        buttonBack: { fontFamily: FONT_CHU },
        buttonSkip: { fontFamily: FONT_CHU },
        buttonClose: { fontFamily: FONT_CHU },
      }}
    />
  );
}

export default TourRunner;
